import { LoadingContainer, ModelList } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { Page } from 'core/components'
import { useLoanTapeTypesList } from 'core/types'

const LoanTapeTypes = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: tapeTypes, isLoading } = useLoanTapeTypesList({
    companyId,
    query: { limit: 100 },
  })

  useClickAction({
    label: 'Create Loan Tape Type',
    onClick: () => history.push(`${url}/create`),
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        <ModelList
          json={tapeTypes}
          title='Loan Tape Types'
          withDetails
          withRelated
          withTimestamps
        />
      </Page>
    </LoadingContainer>
  )
}

export default LoanTapeTypes
